import {
  handler as customerHandler,
  mockCustomer as baseMockCustomer,
} from "./Customer/Customer.query";
import { handler as sellerRecommendedProductsQueryHandler } from "./SellerRecommendedProducts/SellerRecommendedProducts.query";
import { handler as personalisedProductRecommenderQueryHandler } from "./PersonalisedProductRecommender/PersonalisedProductRecommender.query";

export const handlers = [
  customerHandler,
  sellerRecommendedProductsQueryHandler,
  personalisedProductRecommenderQueryHandler,
];

export const mockCustomer = baseMockCustomer;
